import { Duration, proto3, Timestamp } from '@bufbuild/protobuf';
import { createMsgWithdrawDelegatorReward, generateTypes } from '@evmos/eip712';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions/dist/messages/base';
import { fromDuration, toTimestamp } from 'cosmjs-types/helpers';
import { MsgFinalizePacket as MsgFinalizePacketProto } from '../proto/tx_pb';
import { MsgFinalizePacket } from '../ts-client/tx';

const CREATE_MSG_FINALIZE_PACKET_TYPES = (showPacketType: boolean) => ({
  MsgValue: [
    { name: 'sender', type: 'string' },
    { name: 'rollapp_id', type: 'string' },
    { name: 'packet_proof_height', type: 'uint64' },
    ...(showPacketType ? [ { name: 'packet_type', type: 'int32' } ] : []),
    { name: 'packet_src_channel', type: 'string' },
    { name: 'packet_sequence', type: 'uint64' },
  ],
});

export const createTxMsgFinalizePacket = (
  context: TxContext,
  params: MsgFinalizePacket | MsgFinalizePacket[],
): TxPayload => {
  const typedData = createEIP712MsgFinalizePacket(context, params);
  const cosmosMsg = createCosmosMsgFinalizePacket(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgFinalizePacket = (
  context: TxContext,
  params: MsgFinalizePacket | MsgFinalizePacket[],
): EIP712TypedData => {
  const showPacketType = Array.isArray(params) ? params.some((param) => param.packetType) : Boolean(params.packetType);
  const types = generateTypes(CREATE_MSG_FINALIZE_PACKET_TYPES(showPacketType));
  const messageList = Array.isArray(params) ? params : [ params ];
  const messages = messageList.map(createMsgFinalizePacket);
  return { types, message: messages.length === 1 ? messages[0] : messages };
};

const createCosmosMsgFinalizePacket = (context: TxContext, params: MsgFinalizePacket | MsgFinalizePacket[]): any => {
  const messageList = Array.isArray(params) ? params : [ params ];
  return messageList.map((params) => {
    const message = new MsgFinalizePacketProto({
      sender: params.sender,
      rollappId: params.rollappId,
      packetSequence: BigInt(params.packetSequence),
      packetSrcChannel: params.packetSrcChannel,
      packetType: params.packetType as number,
      packetProofHeight: BigInt(params.packetProofHeight),
    });
    return { message, path: MsgFinalizePacketProto.typeName };
  })
};

function createMsgFinalizePacket(params: MsgFinalizePacket): object | object[] {
  return {
    type: 'delayedack/FinalizePacket',
    value: {
      sender: params.sender,
      rollapp_id: params.rollappId,
      packet_proof_height: params.packetProofHeight,
      ...(params.packetType ? { packet_type: params.packetType } : undefined),
      packet_src_channel: params.packetSrcChannel,
      packet_sequence: params.packetSequence,
    },
  };
}

